import { useRef, useEffect } from 'react'
import ApexChart, { ApexOptions } from 'apexcharts'
import { formatDuration } from 'format-helpers'

interface Props {
  onlineTotalSeconds: number
  offlineTotalSeconds: number
}
const ConnectionLogsPieChart = ({
  onlineTotalSeconds,
  offlineTotalSeconds,
}: Props) => {
  const chartRef = useRef(null)

  const series = [onlineTotalSeconds, offlineTotalSeconds]

  const chartOptions: ApexOptions = {
    series,
    chart: {
      type: 'pie',
      fontFamily: 'vazir',
      height: 225,
      animations: {
        enabled: false,
      },
    },
    labels: ['Online', 'Offline'],
    dataLabels: {
      formatter: (val) => (val as number).toFixed(2) + '%', // Force 2 decimal places
    },
    colors: ['#198D10', '#B00C0C'],
    tooltip: {
      y: {
        formatter: (val) => formatDuration(val),
      },
    },
  }

  useEffect(() => {
    const chart = new ApexChart(chartRef.current, chartOptions)
    chart.render()

    return () => chart.destroy()
  }, [series])

  return <div ref={chartRef} style={{ direction: 'ltr' }} />
}

export default ConnectionLogsPieChart
